import { combineReducers } from 'redux';

/** IMPORT REDUCER */
import estoquePostoMonitor from './estoquePostoMonitor/reducer';
import usuarios from './usuarios/reducer';
import padroes from './padroes/reducer';
import msgtcaPosto from './msgtcaPosto/reducer';
import vazaoEquipamentosBicos from './vazaoEquipamentosBicos/reducer';
import modeloEquipamento from './modeloEquipamento/reducer';
import auth from './auth/reducer';
import dialog from './dialog/reducer';
import drawer from './drawer/reducer';
import hooks from './hooks/reducer';
import language from './language/reducer';
import user from './user/reducer';
import usuario from './usuario/reducer';
import veiculoMensagemTCA from './veiculoMensagemTCA/reducer';
import alarmeSistema from './alarmeSistema/reducer';
import alarmesSistemas from './alarmesSistemas/reducer';
import descargaDetalhe from './descargaDetalhe/reducer';
import telatransmitecentral from './telatransmitecentral/reducer';
import abastecimentoA2VF from './abastecimentoA2VF/reducer';
import servicedlgrelestoque from './servicedlgrelestoque/reducer';
import vazaoPosto from './vazaoPosto/reducer';
import estoqueproduto from './estoqueproduto/reducer';
import equipamento from './equipamento/reducer';
import manutConsultCorrecoes from './manutConsultCorrecoes/reducer';
import mensagensTCAGeral from './mensagensTCAGeral/reducer';
import msgtcaPostoLoco from './msgtcaPostoLoco/reducer';
import DlgRelPosto from './DlgRelPosto/reducer';
import vtCertificados from './vtCertificados/reducer';
import apuracaoInventario from './apuracaoInventario/reducer';
import manutExcluirVazamento from './manutExcluirVazamento/reducer';
import manutRetrasmitirUnilog from './manutRetrasmitirUnilog/reducer';
import manutTrocarLocoAbast from './manutTrocarLocoAbast/reducer';
import notasfiscaisrecebidas from './notasFiscaisRecebidas/reducer';

export default combineReducers({
  /** EXPORT REDUCER */
estoquePostoMonitor,
  notasfiscaisrecebidas,
  usuarios,
  padroes,
  mensagensTCAGeral,
  veiculoMensagemTCA,
  msgtcaPostoLoco,
  msgtcaPosto,
  vazaoEquipamentosBicos,
  modeloEquipamento,
  auth,
  drawer,
  language,
  dialog,
  hooks,
  user,
  usuario,
  telatransmitecentral,
  servicedlgrelestoque,
  alarmeSistema,
  alarmesSistemas,
  descargaDetalhe,
  estoqueproduto,
  DlgRelPosto,
  vtCertificados,
  abastecimentoA2VF,
  apuracaoInventario,
  vazaoPosto,
  equipamento,
  manutConsultCorrecoes,
  manutExcluirVazamento,
  manutRetrasmitirUnilog,
  manutTrocarLocoAbast,
});
